import { IS_DEV } from "@constants/env";
import { buildType } from "@helpers/app-identity";
import { Apps } from "@memorang/constants/apps";
import type { CurrentExamContext } from "./types";

const defaultExamContextMap: Record<Apps, CurrentExamContext> = {
	[Apps.TherapyEd]: {
		projectId: IS_DEV ? 9 : 6,
		organizationId: IS_DEV ? 8 : 3,
		examId: "e61873a5-ffd7-4bed-9745-256da36a16d7",
		examName: "NPTE-PT",
		studyPackCollectionId: IS_DEV ? 42 : 80,
		studyPackProductNumericId: 44,
		practiceTestProductNumericId: 66,
		studyPackProductId: "952aca40-c93d-4656-8814-94264f293ac4",
		practiceTestProductId: "3f789553-1d7d-4049-9ceb-cb610e83e102",
		examIcon: "https://icon.memorang.com/icon/icon_exam_21.png",
	},
	[Apps.aavsb]: {
		projectId: IS_DEV ? 9 : 85,
		organizationId: IS_DEV ? 8 : 2,
		examId: "e974b6af-c245-494f-b9b1-f8d25a8c89d5",
		examName: "Veterinary Technician National Exam",
		studyPackCollectionId: 12,
		studyPackProductNumericId: 191,
		practiceTestProductNumericId: 0,
		studyPackProductId: "6f0b4830-1e18-4f63-a3f0-b419cd4496f2",
		practiceTestProductId: "",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
	},
	[Apps.aapa]: {
		projectId: IS_DEV ? 17 : 41,
		organizationId: IS_DEV ? 8 : 36,
		examId: "f08f78be-2ab6-451f-b81c-385b4e8c8840",
		examName: "PANRE",
		studyPackCollectionId: 628,
		studyPackProductNumericId: 307,
		practiceTestProductNumericId: 0,
		studyPackProductId: "550e8400-e29b-41d4-a716-446655440000",
		practiceTestProductId: "",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/aapa/aapa/icons/icon.png",
	},
	[Apps.Psi]: {
		examName: "Life Accident and Health",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
		projectId: IS_DEV ? 7 : 3,
		organizationId: IS_DEV ? 7 : 2,
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		studyPackProductNumericId: 45,
		practiceTestProductNumericId: 72,
		studyPackCollectionId: 263,
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		practiceTestProductId: "8b8d2b39-1780-4b8c-a270-08053153cad3",
	},
	[Apps.cmaa]: {
		examName: "Certified Associate Construction Manager",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-c74b2bbe-16cb-4f04-ab6d-c6f3df67d797/uploads/media/cmaa_associate_construction_manager_prep_bundle.png",
		projectId: IS_DEV ? 7 : 86,
		organizationId: IS_DEV ? 7 : 2,
		examId: "9c3981f8-c690-4bbf-935b-d08557b6d265",
		studyPackCollectionId: 480,
		studyPackProductNumericId: 196,
		studyPackProductId: "0d22c7e8-6783-4a89-b09d-bcb5b5dcb1a3",
		practiceTestProductNumericId: 195,
		practiceTestProductId: "e0165e63-89b4-437e-8f5a-707a04d3b63a",
	},
	[Apps.wpi]: {
		examName: "Water Treatment Class I",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/water_treatment_class_1.png",
		projectId: IS_DEV ? 7 : 84,
		organizationId: IS_DEV ? 7 : 2,
		examId: "921bbcce-51a2-4f38-abcd-39af1bff6138",
		studyPackCollectionId: 0,
		studyPackProductNumericId: 0,
		studyPackProductId: "",
		practiceTestProductNumericId: 211,
		practiceTestProductId: "f3929f8c-1644-4fd1-abe0-473df69423a5",
	},
	[Apps.wocncb]: {
		examName: "Certified Continence Care Nurse",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-4c80ce98-ef6c-41c8-ab54-f4db19c75136/uploads/media/wocncb_continence_care_nurse_prep_bundle.png",
		projectId: IS_DEV ? 7 : 87,
		organizationId: IS_DEV ? 7 : 2,
		examId: "02b4592b-7b47-450d-8bb6-a63d82e43953",
		studyPackCollectionId: 802,
		studyPackProductNumericId: 375,
		studyPackProductId: "82b72eb9-8bff-402b-929d-9abd7d0b0ee4",
		practiceTestProductNumericId: 199,
		practiceTestProductId: "dd7e36ee-90fb-4cc1-8e14-78b1b612bfc9",
	},
	[Apps.act]: {
		examName: "ACT",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/ACT/icons/icon.png",
		projectId: IS_DEV ? 7 : 108,
		organizationId: IS_DEV ? 7 : 70,
		examId: "ad17e478-7727-4667-b8d5-5c8bcc0d0830",
		studyPackCollectionId: 651,
		studyPackProductNumericId: 313,
		studyPackProductId: "8db8bdf0-e684-4096-9a25-608ff807c159",
		practiceTestProductNumericId: 315,
		practiceTestProductId: "a706513b-047b-4c28-a38c-23c2d1474ee6",
	},
	[Apps.faa]: {
		examName: "Unmanned Aircraft General (UAG)",
		examIcon:
			"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/icon.png",
		projectId: IS_DEV ? 81 : 54,
		organizationId: IS_DEV ? 7 : 2,
		examId: "87bce8a4-d114-4b38-9b89-1441483e83ae",
		studyPackProductNumericId: 188,
		practiceTestProductNumericId: 187,
		studyPackCollectionId: 40,
		studyPackProductId: "1581febf-d426-49d5-8f5b-51d55509be86",
		practiceTestProductId: "35f12bb1-f9d8-48f0-97f3-26eadf0990ac",
	},
	[Apps.cambridge]: {
		examName: "English Hub",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/cambridge/icons/icon.png",
		projectId: IS_DEV ? 62 : 48,
		organizationId: IS_DEV ? 51 : 47,
		examId: IS_DEV
			? "894559fc-2a9e-428d-bbfd-eee0042417b6"
			: "894559fc-2a9e-428d-bbfd-eee0042417b6",
		studyPackProductNumericId: 0,
		studyPackCollectionId: 39,
		studyPackProductId: "",
		practiceTestProductNumericId: 190,
		practiceTestProductId: "3d72cde7-47f7-4d4f-8ea0-c2ad24d3cc89",
	},
	[Apps.toefl]: {
		projectId: IS_DEV ? 61 : 47,
		organizationId: IS_DEV ? 29 : 24,
		examId: "e783a8c3-951c-48c3-9b8a-fd464a27d1d3",
		studyPackProductNumericId: 178,
		studyPackCollectionId: 38,
		examName: "TOEFL",
		studyPackProductId: "6da87b56-3d30-450a-b097-20fc5a360b39",
		practiceTestProductId: "",
		examIcon:
			"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png",
	},
	[Apps.Jbjs]: {
		projectId: IS_DEV ? 13 : 10,
		organizationId: IS_DEV ? 17 : 8,
		examId: "06be055e-878c-43c5-942e-cc78a7d9aa5a",
		examName: "JBJS ACE",
		studyPackProductNumericId: IS_DEV ? 106 : 194,
		studyPackCollectionId: 20,
		freeStudyPackCollectionId: 835,
		studyPackProductId: "",
		practiceTestProductId: "",
		documentsCollectionId: 20,
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_default_light_new.png",
	},
	[Apps.nascla]: {
		examName: "NASCLA Commercial General Building Contractor",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-ea9e2b44-760e-4963-8255-7727cda0efe4/projects/project-6635a8d9-38e4-4051-928c-42df9e591999/uploads/media/commercial_building_contractor_exam.png",
		projectId: IS_DEV ? 7 : 91,
		organizationId: IS_DEV ? 7 : 2,
		examId: "fbe1b648-7330-4fa6-a652-f2872a7d0997",
		studyPackCollectionId: 522,
		studyPackProductNumericId: 227,
		practiceTestProductNumericId: 226,
		studyPackProductId: "8fe8b405-88ed-40d0-82c1-4fbe8fe12756",
		practiceTestProductId: "1e5447c3-ba0b-44e3-ab1e-d5c0429d1672",
	},
	[Apps.hiset]: {
		examName: "Life Accident and Health",
		studyPackProductNumericId: 45,
		practiceTestProductNumericId: 72,
		studyPackCollectionId: 88,
		projectId: IS_DEV ? 7 : 3,
		organizationId: IS_DEV ? 7 : 2,
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		practiceTestProductId: "8b8d2b39-1780-4b8c-a270-08053153cad3",
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
	},
	[Apps.rockettestprep]: {
		examName: "Rocket Test Prep",
		studyPackProductNumericId: 267,
		practiceTestProductNumericId: 268,
		studyPackCollectionId: 685,
		projectId: IS_DEV ? 18 : 7,
		organizationId: IS_DEV ? 2 : 4,
		studyPackProductId: "47d9991e-1aac-47d0-8b76-8978bccb551c",
		practiceTestProductId: "c11bc07f-1408-4fd6-a42d-27600cf4fae9",
		examId: "36d854a6-8198-4838-8816-e027679bed9a",
		examIcon: "https://icon.memorang.com/icon/acme.png",
	},
	[Apps.toeic]: {
		examName: "TOEIC Link",
		studyPackProductNumericId: 392,
		freeStudyPackCollectionId: 813,
		practiceTestProductNumericId: 0,
		studyPackCollectionId: 759,
		projectId: IS_DEV ? 18 : 95,
		organizationId: IS_DEV ? 2 : 24,
		studyPackProductId: "5665958c-9ef6-41f6-bac6-eed44ceb53e0",
		practiceTestProductId: "",
		examId: "344ea4cf-6cef-42b9-98a6-c93dcea9f2d2",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/exam_icon.png",
	},
	[Apps.naplex]: {
		examName: "NAPLEX Exam",
		studyPackProductNumericId: 409,
		practiceTestProductNumericId: 410,
		studyPackCollectionId: 673,
		legacySessionsCollectionId: 792,
		projectId: 28,
		organizationId: 27,
		studyPackProductId: "28065bc1-7b55-45ff-9e01-2b631b84c957",
		practiceTestProductId: "d0b01be4-d1c9-4b86-8ff9-c3a98a640354",
		examId: "8c235fcd-45fc-4405-b4db-c10734a640cb",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png",
	},
	[Apps.pte]: {
		examName: "Pearson PTE Core",
		studyPackProductNumericId: IS_DEV ? 294 : 390,
		practiceTestProductNumericId: IS_DEV ? 290 : 388,
		studyPackCollectionId: IS_DEV ? 693 : 758,
		freeStudyPackCollectionId: 780,
		projectId: IS_DEV ? 216 : 107,
		organizationId: IS_DEV ? 33 : 28,
		prepNumericId: IS_DEV ? 294 : 402,
		prepId: IS_DEV
			? "0103c902-e73d-4dd5-911e-4aac611f3209"
			: "0ba91657-25a8-4cc7-a0ca-a533d5b78965",
		studyPackProductId: IS_DEV
			? "0103c902-e73d-4dd5-911e-4aac611f3209"
			: "131d17f6-5fba-41bd-9125-df36129d2b31",
		practiceTestProductId: IS_DEV
			? "3bb50ad7-fb15-4ed3-97b8-92644298b794"
			: "5d0cc221-c24a-4216-b7cb-9cde1e5a480b",
		examId: IS_DEV
			? "c11b0f17-a02a-49ab-b2ad-49c5851da71c"
			: "e84fe998-e105-4d7e-a722-afb49d7ace0e",
		examIcon:
			"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/org-dbc5fbb0-be37-49e3-b0a2-31ff00822e14/projects/project-e6bc78c9-96f1-45a0-b3ad-858748f9ae9f/uploads/media/pte-core.png",
	},
};

export const defaultExamContext = defaultExamContextMap[buildType];
